// extracted by mini-css-extract-plugin
export default {"icon":"Num07_icon__E6j2h"};